import { numberFormat } from "utils"

export const columns = [
  // {
  //   field: 'ShowDetail',
  //   headerName: '',
  //   width: 40,
  //   align: 'center',
  //   renderCell: (params) => {
  //   return (
  //     <IconButton size="small" >
  //     <ArticleRounded color="primary"/>
  //     </IconButton>
  //   )}
  // },
  {
    field: "No",
    headerName: "No.",
    width: 50,
    align: 'center',
  },
  {
    field: "CusSNm",
    headerName: "ลูกค้า",
    width: 165,
  },
  {
    field: "NumJo",
    headerName: "จำนวนเที่ยว",
    width: 90,
    align: "center"
  },
  {
    field: "DrvFixCost",
    headerName: "เงินเดือน พขร.",
    width: 130,
    align: 'right',
    valueFormatter: ({value}) => value === null? "": numberFormat(value),
  },
  {
    field: "TripAmnt",
    headerName: "ค่าเที่ยว พขร",
    width: 130,
    align: 'right',
    valueFormatter: ({value}) => value === null? "": numberFormat(value),
  },
  {
    field: "CostAmnt",
    headerName: "ต้นทุนอื่นๆ",
    width: 130,
    align: 'right',
    valueFormatter: ({value}) => value === null? "": numberFormat(value),
  },
  {
    field: "OprTotal",
    headerName: "รวมต้นทุน",
    width: 130,
    align: 'right',
    valueFormatter: ({value}) => value === null? "": numberFormat(value),
  },
  {
    field: "InvTransAmnt",
    headerName: "รายได้ค่าขนส่ง",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "" : numberFormat(value),
  },
  {
    field: "InvOthOwnRcptAmnt",
    headerName: "ใบเสร็จบริษัทอื่น",
    width: 130,
    align: 'right',
    valueFormatter: ({ value }) => value === null ? "" : numberFormat(value),
  },
  {
    field: "InvOwnRcptAmnt",
    headerName: "รวมใบเสร็จบริษัท",
    width: 130,
    align: 'right',
    valueFormatter: ({value}) => value === null? "": numberFormat(value),
  },
  {
    field: "InvCusRcptAmnt",
    headerName: "รายได้ใบเสร็จลูกค้า",
    width: 130,
    align: 'right',
    valueFormatter: ({value}) => value === null? "": numberFormat(value),
  },
  {
    field: "InvTotal",
    headerName: "รวมรายได้",
    width: 130,
    align: 'right',
    valueFormatter: ({value}) => value === null? "": numberFormat(value),
  },
  {
    field: "Profit",
    headerName: "กำไรเบื้องต้น",
    width: 130,
    align: 'right',
    valueFormatter: ({value}) => value === null? "": numberFormat(value),
  },
  {
    field: "IncPerJo",
    headerName: "ใบเสร็จบริษัท/เที่ยว",
    width: 130,
    align: 'right',
    valueGetter: ({row}) => row.NumJo === 0? "": row.InvOwnRcptAmnt / +row.NumJo,
    valueFormatter: ({value}) => value === null? "": numberFormat(value),
  },
  {
    field: "AdvPerJo",
    headerName: "ใบเสร็จลูกค้า/เที่ยว",
    width: 130,
    align: 'right',
    valueGetter: ({row}) => row.NumJo === 0? "": row.InvCusRcptAmnt / +row.NumJo,
    valueFormatter: ({value}) => value === null? "": numberFormat(value),
  },
  {
    field: "ProfitPerJo",
    headerName: "กำไรเบื้องต้น/เที่ยว",
    width: 130,
    align: 'right',
    valueGetter: ({row}) => row.NumJo === 0? "": row.Profit / +row.NumJo,
    valueFormatter: ({value}) => value === null? "": numberFormat(value),
  },
]